import type { ReactNode } from "react";

import { splitKeys } from "./catalog";

/** A key chord as `<kbd>` tokens; alternatives keep their "or". */
export function Keys({ keys }: { keys: string }): ReactNode {
  return (
    <span className="flex flex-wrap items-center gap-1">
      {splitKeys(keys).map((token, index) =>
        token === "or" ? (
          <span key={`or-${String(index)}`} className="text-xs text-muted">
            or
          </span>
        ) : (
          <kbd
            key={`${token}-${String(index)}`}
            className="rounded border border-line bg-surface px-1.5 py-0.5 font-mono text-xs text-ink"
          >
            {token}
          </kbd>
        ),
      )}
    </span>
  );
}
